var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticStyle:{"min-height":"40em"},attrs:{"id":"cdl_xp_pie"}})])
}]

export { render, staticRenderFns }